import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { QueryKey } from '@ge/models/constants';
import { useTableFilter } from '@ge/shared/data-hooks/use-table-filter';
import { sorter } from '@ge/util/metric-sorter';

import { getExistingDamageDetailsByAssetId } from '../services/damages';

export const useAssetDamageDetails = ({
  assetId,
  filters,
  search,
  sortMetric,
  sortDirection,
  isAuthorizedToViewAssetDamage,
}) => {
  const params = {
    assetIds: assetId,
    components: 'Main Bearing,Gearbox,Generator,Pitch Bearing',
    status: 'Open,Closed',
  };

  const { data: assetDamagesData, isLoading } = useQuery(
    [QueryKey.EXISTING_DAMAGE_DETAILS, params],
    () => getExistingDamageDetailsByAssetId(params),
    {
      enabled: Boolean(assetId && isAuthorizedToViewAssetDamage),
    },
  );

  const assetDamages = assetDamagesData?.map((assetDamage) => ({
    ...assetDamage,
    ['creationDate']: assetDamage?.creationDate?.toString() || '',
    ['indicationDate']: assetDamage?.indicationDate?.toString() || '',
    ['inspectionDate']: assetDamage?.inspectionDate?.toString() || '',
    ['followupDate']: assetDamage?.followupDate?.toString() || '',
  }));

  const { data, filterValues } = useTableFilter({
    data: assetDamages?.sort(sorter(sortMetric, sortDirection)),
    filters,
    search,
  });
  return useMemo(
    () => ({
      data: data?.length ? data : [],
      isLoading,
      filterValues,
    }),
    [data, isLoading, filterValues],
  );
};
